const TAURI_EVENTS = {
  NETWORK_STATUS_CHANGE: "network-status-change",
  DEEP_LINK_DETECTED: "deep-link-detected",
} as const;

type NetworkStatusChangeEventPayload = "Online" | "Offline";
type DeepLinkDetectedEventPayload = { url: string };

export { TAURI_EVENTS, type NetworkStatusChangeEventPayload, type DeepLinkDetectedEventPayload };
